const ErrorCodes = {
  VALIDATION_ERROR: 1000,
  INVALID_USERNAME_PASSWORD: 2000,
};

export default ErrorCodes;
